
const contentview = [{"key":"contentview.title","string":"Vložený příspěvek do znalostní databáze"},{"key":"contentview.add_content_button","string":"Vlož příspěvek"},{"key":"contentview.no_content_added","string":"Zatím jste ještě nevložil do znalostní databáze žádný příspěvek. "},{"key":"contentview.table.title","string":"Název"},{"key":"contentview.table.author","string":"Autor"},{"key":"contentview.table.year","string":"Rok"},{"key":"contentview.full_text","string":"Přejít na fulltext"}]

export default contentview



// WEBPACK FOOTER //
// ./src/i18n/cs/addcontent/contentview.js